import TransmissionJson from "./transmissionJson";

export default class Transmission {
  description: string | null;
  type: string | null;

  constructor() {
    this.description = null;
    this.type = null;
  }

  static fromJSON(json: TransmissionJson | null): Transmission {
    const transmission = new Transmission();

    if (json === null) {
      return transmission;
    }

    transmission.description = json.description;
    transmission.type = json.type;

    return transmission;
  }
}
